"use client";

import useSession from "@/hooks/useSession";
import { type ReactNode } from "react";
import { AidaStoreProvider } from "../../providers/stores/AidaStoreProvider";
import { AidaButton } from "../AidaButton";
import { AidaWindow } from "../AidaWindow";
export interface AidaProviderProps {
  children: ReactNode;
}
export const AidaProvider = ({
  children
}: AidaProviderProps) => {
  const session = useSession();
  return <AidaStoreProvider data-sentry-element="AidaStoreProvider" data-sentry-component="AidaProvider" data-sentry-source-file="AidaProvider.tsx">
      {children}
      {session && <>
          <AidaButton />
          <AidaWindow />
        </>}
    </AidaStoreProvider>;
};